import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import PreviewReducer, { PreviewState, initialPreviewState } from './reducers/preview'
import type { PreviewDispatch } from './reducers/preview'

type Context = [PreviewState, PreviewDispatch]

const { context: PreviewContext, hook: usePreview } = createContext<Context>()

const PreviewProvider = ({ children }: React.PropsWithChildren<object>) => {
  const memoizedReducer = useCallback(PreviewReducer, [])
  const [state, dispatch] = React.useReducer(memoizedReducer, initialPreviewState())

  return <PreviewContext.Provider value={[state, dispatch]}>{children}</PreviewContext.Provider>
}

export { PreviewProvider, usePreview }
